import { useRef, useState } from 'react';

import { Modal } from '@iwoca/orion';

import LoadingGif from './iwoca-loader.gif';
import { ExportCSV } from '../ExportCSV/ExportCSV';

export const ExportCustomers = ({
  filters,
}: {
  filters?: {
    status?: string | null;
    stage?: string | null;
    searchQuery?: string;
  };
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const controllerRef = useRef<AbortController | null>(null);

  return (
    <>
      <ExportCSV
        fetcher={({ stateKey }) => {
          controllerRef.current = new AbortController();
          const abortSignal = controllerRef.current.signal;
          // eslint-disable-next-line iwoca/prefer-lapi-client
          return fetch(
            `/api/iwocapay/seller/${stateKey}/customers_download/?` +
              new URLSearchParams({
                ...(filters?.stage && { application_stage: filters.stage }),
                ...(filters?.status && {
                  spending_limit_status: filters.status,
                }),
                ...(filters?.searchQuery && {
                  search: filters.searchQuery,
                  search_fields: 'company_name',
                }),
              }),
            { signal: abortSignal },
          );
        }}
        setIsLoading={setIsLoading}
      />
      <Modal
        isOpen={isLoading}
        onClose={() => {
          controllerRef.current?.abort();
          setIsLoading(false);
        }}
        title="We’re getting your export ready"
        closeIcon
      >
        <div className="flex flex-col gap-l">
          <div className="flex items-center justify-center">
            <img src={LoadingGif} alt="loading" width={185} height={185}></img>
          </div>
          <div className="text-l font-reg">
            Since you’re exporting a large file this might take longer than
            usual.
          </div>
          <div className="mb-l">
            💡 You can speed things up next time by applying more filters.
          </div>
        </div>
      </Modal>
    </>
  );
};
